import "isomorphic-fetch";
import Cookies from "js-cookie";

class Api {
  constructor(baseUrl, delay = 0) {
    this.baseUrl = baseUrl;
    this.delay = delay;
  }

  objectToParams(obj) {
    var pairs = [];
    for (var key in obj)
      if (obj.hasOwnProperty(key))
        pairs.push(
          encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
        );
    return pairs.join("&");
  }

  paramsToObject(params) {
    let query = params.substr(1);
    let result = {};
    query.split("&").forEach(function(part) {
      let item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  }

  get(url, params = {}, config = {}) {
    let queryParams = this.objectToParams(params);
    let urlWithQueryParams =
      `${this.baseUrl}${url}` + (queryParams ? "?" + queryParams : "");
    return this.request(urlWithQueryParams, config);
  }

  post(url, body) {
    return this.request(`${this.baseUrl}${url}`, {
      method: "POST",
      body: JSON.stringify(body)
    });
  }

  put(url, body) {
    return this.request(`${this.baseUrl}${url}`, {
      method: "PUT",
      body: JSON.stringify(body)
    });
  }

  delete(url) {
    return this.request(`${this.baseUrl}${url}`, {
      method: "DELETE"
    });
  }

  redirect(url) {
    window.location = url;
  }

  request(url, config = {}, checkFor401 = true) {
    let headers = {      
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const token = Cookies.get("token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    
    if(config['headers']) {
      headers = {
        ...headers,
        ...config['headers']
      }     
      delete config['headers']
    }    

    config = Object.assign(
      {
        headers: headers
      },
      config
    );

    return fetch(url, config)
      .then(response => {
        if (checkFor401) {
          if (response.status === 401) {
            Cookies.remove("token");
            this.redirect("/");
            return;
          }
        }

        if (response.ok) {
          try {
            return response.json();
          } catch (e) {
            return {};
          }
        } else {
          let error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .catch(error => {
        if (error.response) {
          return error.response.json().then(error_details => {
            error.details = error_details;
            throw error;
          });
        }
        return error;
      });
  }
}

export const factory = baseUrl => {
  return new Api(baseUrl);
};

export default factory(process.env.REACT_APP_API_BASE_URL);



// WEBPACK FOOTER //
// ./src/ui/src/api.js